import React, { Component } from "react";
import { Form, Input, Button, Divider, message } from "antd";
import styles from "../index.module.less";
import { inject, observer } from "mobx-react";
import co from "co";
import { checkArticleBalance } from "services/options";

const FormItem = Form.Item;

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},
	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class ArticleForgeForm extends Component {
	render() {
		const balanceText = <span><b>API Status:</b> {this.props.balance}</span>;
		return (
			<Form layout="vertical" className={styles.rxform}>
				<FormItem label="API Key">
					{this.props.form.getFieldDecorator("articleForge.apiKey")(
						<Input type="text" />
					)}
				</FormItem>
				<FormItem>
					<Button type="primary" onClick={this.props.checkBalance} loading={this.props.checking}>Check API</Button>
				</FormItem>
				<Divider type="horizontal" />
				{balanceText}				
			</Form>
		);
	}
}

@inject("rootStore")
@observer
class ArticleForge extends Component {
	constructor(props) {
		super(props);
		this.state = {
			checking: false,
			result: ""
		}
	}

	checkBalance = () => {
		const {
			rootStore: { optionsStore }
		} = this.props;		
		
		const options = optionsStore.stateForm;
		const apiKey = !options.articleForge ? "" : options.articleForge.apiKey ? options.articleForge.apiKey.value : "";		
		if (!apiKey) {
			//do nothing;
			return;
		}
		co (function*() {
			this.setState({
				checking: true
			})

			const response = yield checkArticleBalance({
				articleSource: "ArticleForge",
				inputInfo: JSON.stringify({
					apiKey					
				})
			})

			this.setState({
				checking: false
			})

			if (!response) {
				message.error("Failed to check Article Forge API. Unknown error.");
				return;
			}

			if (response.error) {
				message.error(response.error.message);
				return;
			}

			this.setState({
				balance: response.balance
			})
		}.bind(this))

	}

	onFieldsChange = changedFields => {
		const {
			rootStore: { optionsStore }
		} = this.props;

		optionsStore.formChanged(changedFields);
    };
    
	mapPropsToFields = () => {
		const {
			rootStore: { optionsStore }
		} = this.props;

		const options = optionsStore.stateForm;

		return {
			articleForge: {
				apiKey: options.articleForge ? Form.createFormField(options.articleForge.apiKey) : undefined
			}
		};
	};
	render() {
		return (
			<ArticleForgeForm
				fields={this.mapPropsToFields()}
				onFieldsChange={this.onFieldsChange}
				checking={this.state.checking}
				balance={this.state.balance}
				checkBalance={this.checkBalance}
			/>
		);
	}
}

export default ArticleForge;
